import { StateStorage } from "../StateStorage";

export type Reducer<TState, TAction> = (state: TState, action: TAction) => TState;

export default function persistStateReducer<TState, TAction>(storage: StateStorage<TState>, initialState: TState, innerReducer: Reducer<TState, TAction>): Reducer<TState, TAction> {
    let obj = storage.get() ?? initialState;

    // Clean up hasInteracted flag on page load - don't persist across browser refreshes
    if (obj && (obj as any).visuals) {
        obj = {
            ...obj,
            visuals: {
                ...(obj as any).visuals,
                hasInteracted: undefined
            }
        };
    }

    return (state = obj, action) => {
        const res = innerReducer(state, action);
        storage.set(res);
        return res;
    };
}